
var allBreakpoints = Unison.fetch.all();

var myStartBreakpointFunction = function() {
	$(".sidebar").mCustomScrollbar("destroy");
	$(".sidebar__result").mCustomScrollbar("destroy");
    $(".sliding-pane__inner").mCustomScrollbar("destroy");
};


var myTabletBreakpointFunction = function() {
	$(".sidebar").mCustomScrollbar("destroy");
	$(".sidebar__result").mCustomScrollbar({
		theme: "dark",
		scrollButtoms: 150,
		scrollInertia: 150,
		mouseWheel: true,
		updateOnContentResize: true,
		alwaysShowScrollbar: 1,
	});
};

var myDesktopBreakpointFunction = function() {
	$(".sidebar__result").mCustomScrollbar("destroy");
	$(".sidebar").mCustomScrollbar({
		theme: "dark",
		scrollButtoms: 150,
		scrollInertia: 150,
		mouseWheel: true,
		updateOnContentResize: true,
		alwaysShowScrollbar: 1,
		callbacks:{
			onScrollStart:function(){
				$('.sidebar__helper a').addClass('show');
			},
		    onTotalScrollBack:function(){
				$('.sidebar__helper a').removeClass('show');
			}
		}
	});
};


function isMobileOrTablet() {
    const userAgent = this.getUserAgent();
    const userAgentPart = userAgent.substr(0, 4);
    let mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgentPart);
    if(!mobile && userAgent.indexOf('Macintosh') > -1){
        if('ontouchend' in document){
            return true;
        }
    }
    return mobile;
}

function getUserAgent() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera || null;
    if (!userAgent)
        throw new Error('Failed to look for user agent information.');
    return userAgent;
}

var isMobile = false;
function MobileCheck() {
    if (isMobileOrTablet()) {
        isMobile = true;
    }
}

/*
########    #######   ##     ##       ########   ########      ###     ########   ##    ##   
##     ##  ##     ##  ###   ###       ##     ##  ##           ## ##    ##     ##   ##  ##    
##     ##  ##     ##  #### ####       ##     ##  ##          ##   ##   ##     ##    ####     
##     ##  ##     ##  ## ### ##       ########   ######     ##     ##  ##     ##     ##      
##     ##  ##     ##  ##     ##       ##   ##    ##         #########  ##     ##     ##      
##     ##  ##     ##  ##     ##       ##    ##   ##         ##     ##  ##     ##     ##      
########    #######   ##     ##       ##     ##  ########   ##     ##  ########      ##      
*/

$(document).ready(function() {

    MobileCheck();
    let today = new Date();
    let past = new Date( sessionStorage.getItem('rgeTime') );
    let Difference_In_Time = Math.abs(today - past);
    let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    if( ( Difference_In_Days > 1 || !sessionStorage.getItem('rgeRedirect') || !sessionStorage.getItem('rgeTime') ) && !isMobile) {

        sessionStorage.clear();
        sessionStorage.setItem('rgeTime',today);
        sessionStorage.setItem('rgeRedirect', true);

        window.location = '/house/';

    }

    sessionStorage.setItem('rgeRedirect', false);

    if(isMobile && ( window.location.pathname == '/house/' || window.location.pathname == '/house') ){
        window.location = '/';
    }

	/**
	 * Test si les Media Queries sont supportées
	 * Ajoute la classe 'mq' au tag HTML si c'est le cas
	 */
	if ( Modernizr.mq('only all') ) {
		jQuery('html').addClass('mq');
	} else {
		jQuery('html').addClass('no-mq');
	}

	/**
	 * Browser detect : masquage de la bannière
	 */
	$('.browserdetect__close').click(function(e) {
		e.preventDefault();
		$('.browserdetect').addClass('browserdetect--hidden');
	});

	/**
	 * MatchHeight [GRID]
	 */
	$(".harmonize").matchHeight();


	/* Filter Results Height */
	Unison.on('start', function() {
		myStartBreakpointFunction();
	});

	Unison.on('tablet', function() {
		myTabletBreakpointFunction();
	});

	Unison.on('desktop', function() {
		myDesktopBreakpointFunction();
	});

	// MAP

	$('.sidebar__helper a').click(function(e) {
		e.preventDefault();
		alert('coucou');
		$('.sidebar').mCustomScrollbar('scrollTo', 'top', null);
	});

	$('.sidebar__filter-activesearch .btn').click(function(e) {
		e.preventDefault();
		$('.sidebar').removeClass('mapshow');
		var speed = 200; // Durée de l'animation (en ms)
		$('.sidebar__filter-container').animate( { scrollTop: $('.sidebar__filter-container').offset().top }, speed ); // Go
		return false;
	});

    /*if( !sessionStorage.getItem('warning-rge') ) {
        swal(
            "ATTENTION",
            "Suite à l’évolution de la nomenclature RGE en date du 1er janvier 2021, nous sommes dans l’attente de confirmation des nouvelles qualifications des entreprises. Il est important de contacter l’entreprise directement pour s’assurer de l’exactitude de leurs domaines de travaux.",
            "warning"
        );
        sessionStorage.setItem('warning-rge', true);
    }*/
	
});
